import React from "react";
import AddProductButton from "./AddProductButton";

const ComparisonRowAddProductButton = ({products, label, callback}) => {
    return (
        <div className="row buttons-row">
            <div>&nbsp;</div>
            {products.map(product => (
                <AddProductButton key={product.id} callback={callback} label={label} product={product}/>
            ))}
        </div>
    )
}
export default ComparisonRowAddProductButton;